import React from 'react';
import CheckboxTree from 'react-checkbox-tree';
import useTreeView from './useTreeView';
import { ITreeNode } from '../../common/types/commonTypes';
import { ExpandopenIcon } from '../ui/icons';
import {
  IGroupAlerts,
  ISelectGroupState,
} from '../../common/types/alertsTypes';
import { Form } from 'react-bootstrap';

interface IProps {
  nodes: ITreeNode[];
  onDataFromTreeView?: (selectedGroup: IGroupAlerts) => void;
  isModalOrg?: boolean;
  setIsEmptyGroupShown?: React.Dispatch<React.SetStateAction<boolean>>;
  setSearchTerm?: React.Dispatch<React.SetStateAction<string>>;
  isSearching?: boolean;
  isMultiSelect?: boolean;
  selectGroupState?: ISelectGroupState;
  setSelectGroupState?: (state: ISelectGroupState) => void;
  children?: never[];
  checkedBox?: string[];
  isSelectAllEnabled?: boolean;
  reload?: boolean;
  setReload?: React.Dispatch<React.SetStateAction<boolean>>;
}

const TreeView = (props: IProps) => {
  const {
    treeViewProps,
    selectedGroup,
    handleSelectAllChange,
    selectAllChecked,
  } = useTreeView(props);
  const { isModalOrg, onDataFromTreeView, isSelectAllEnabled } = props;

  React.useEffect(() => {
    if (isModalOrg && onDataFromTreeView && selectedGroup) {
      onDataFromTreeView(selectedGroup);
    }
  }, [isModalOrg, selectedGroup]);

  return (
    <>
      {isSelectAllEnabled && (
        <Form>
          {['checkbox'].map((type) => (
            <div key={type}>
              <Form.Check
                type='checkbox'
                id='selectall'
                label='Select All'
                checked={selectAllChecked}
                onChange={handleSelectAllChange}
              />
            </div>
          ))}
        </Form>
      )}
      <CheckboxTree
        icons={{
          expandClose: <ExpandopenIcon />,
          expandOpen: <ExpandopenIcon />,
        }}
        {...treeViewProps}
      />
    </>
  );
};

export default TreeView;

TreeView.defaultProps = {
  isModalOrg: false,
  isMultiSelect: false,
  isSelectAllEnabled: false,
};
